import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "../RenderStyle.css";

import EC_Render from "../../../../../UiComponents/EC_Render";
import Navbar from '../../../../../UiComponents/June2026/Navbar';
import RenderNavbar from '../../../../../UiComponents/June2026/RenderNavbar';
import RenderSettings from '../../RenderSettings';
import RendersTable from '../RendersTable';
import { Scrollx_animate } from "../../../../../assets/icons";

import { renderSettingsOptions, fpsNumAndDen, commonFps, DEFAULT_RENDER_FPS, format, isAlphaRenderFormat } from "../../render.constants";
import { setCurrentNotification } from "../../../../utils/global";

// Redux
import { useDispatch, useSelector } from "react-redux";
import { increaseRenderCnt } from "../../../../../Redux/actions/authActions";
import { requestRenderXVideo, deleteRenders, deleteAllRenders, downloadRender } from "../../../../../Redux/actions/projectActions";
import ConfirmationModal from "../../../../../Components/ConfirmationModal/ConfirmationModal";
import { getCurrentPlan, getRendersPlan, getNotification, addNotifications, getUserAllInformation, markRenderDone } from "../../../../../Redux/actions/commonActtion";
import { updatePreviewScale } from "../../../../../Redux/actions/applicationActions";

import { toast } from "react-toastify";
import CustomToast, { customToatStyle } from "../../../../../Components/CustomToast/CustomToast";

import {
  generateBlockImages,
  generateEndHoldAssets,
  createBlankPng,
} from "../../../../utils/generateCreditsPng";
import {
  resolveOpaqueMatteColor,
  getScrollBlockBackgroundStyle,
} from "../../../utils/projectBackground";
import { getScrollRunningTime } from "../../getScrollRunningTime";
import {
  DEFAULT_SPEED,
  getSpfForSpeed,
  isValidSpeed,
} from "../../scrollSpeedMap";
import {
  persistStoredResolution,
  persistStoredFps,
  persistStoredSpeed,
  resolutionsForAspectFrame,
} from "../../../Preview/previewPlaybackUtils";
import { getRenderEndHoldTiming } from "../../../Preview/scrollEndBehavior";
import { isCanvasPreviewEnabled } from "../../../CanvasPreview/flags";
import { prepareCanvasExport } from "../../../CanvasPreview/exportCanvas";

const freeRenderFormats = Object.entries(format).map(([key, value]) => ({ label: key, value: value }));
const freeFramRate = commonFps.map((fps) => ({ label: fps, value: 23.976 }));
const freeRenderSettingsOptions = Object.keys(renderSettingsOptions).map(
  (resolutionType) => {
    return { label: resolutionType, value: resolutionType };
  },
);
const defaultResolution = "1280 x 720";
const DEFAULT_FORMAT = "H264";
const DEFAULT_FPS = DEFAULT_RENDER_FPS;
const mesg = "Rendering in Progress Your render is currently being processed. You will receive a notification via email when its complete. Thank you for your patience!";

const ScrollRender = ({
  renderOpen,
  setRenderOpen,
  currentBlockIdx,
  isRenderExport,
  setIsRenderExport,
  aspectRatio_FrameSize,
  setAspectRatio_FrameSize,
}) => {
  console.log("1 ScrollRender Component Mounted Props => ", { renderOpen, setRenderOpen, currentBlockIdx, isRenderExport, setIsRenderExport });
  const user = JSON.parse(localStorage.getItem("user"));
  const { projectId } = useParams();

  const navigate = useNavigate();  
  const dispatch = useDispatch();

  const [aspectRatio, setAspectRatio] = useState("1.78");
  const [isEmailSend, setIsEmailSend] = useState(true);
  const [isSuccessOpen, setIsSuccessOpen] = useState(false);

  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isUpgradeOpen, IsUpgradeOpen] = useState(false);
  const [isPlanShow, setIsPlanShow] = useState(false);

  const { isCard, _id, settings: projectSettings, credits, fontStyle } = useSelector((state) => state?.project);
  let { isLoading, renders } = useSelector((state) => state?.project);
  const { renderPlan, subscriptionStatus } = useSelector((state) => state.commonReducer);
  const commonReducer = useSelector((state) => state?.commonReducer);

  const { userData, renderDone, currentPlan } = useSelector((state) => state?.commonReducer);
  const iscurrentPlanActivate = Object.keys(currentPlan).length === 0;
  const currentPlanDetails = currentPlan?.plan?.plan_detail;
  const [isUserPaid, setIsUserPaid] = useState(currentPlan.isExpired ? false : true);
  

  useEffect(() => {
    setIsUserPaid(currentPlan.isExpired ? false : true);
  }, [currentPlan.isExpired]);

  // if user is paid, we are getting the settings from local storage, if user is not paid, we are removing the settings from local storage
  let renderSettingData = null;
  if (isUserPaid) {
    renderSettingData = JSON.parse(localStorage.getItem("renderSettings"));
  } else if (!isUserPaid) {
    if (renderSettingData) {
      localStorage.removeItem("renderSettings");
    }
  }
  // const renderSettingFormat = renderSettingData !== null ? renderSettingData.format !== "H264" ? renderSettingData.format.substring(6) : "H264" : "";

  const storedFormat = renderSettingData?.format;
  const storedFps = Number(renderSettingData?.fps);

  // Getting default settings from local storage, if renderSettings is available otherwise we are taking default setting
  const [resolution, setResolution] = useState(
    renderSettingData?.resolution && renderSettingsOptions[renderSettingData.resolution]
      ? renderSettingData.resolution
      : defaultResolution,
  );
  const [formats, setFormats] = useState(
    storedFormat ? storedFormat : DEFAULT_FORMAT,
  );
  const [fps, setFps] = useState(
    commonFps.some((rate) => rate === storedFps) ? storedFps : DEFAULT_FPS,
  );
  const [speed, setSpeed] = useState(() => {
    const stored = renderSettingData?.speed;
    return isValidSpeed(stored) ? Number(stored) : DEFAULT_SPEED;
  });

  const resolutionKeys = Object.keys(renderSettingsOptions);
  const resolutionIndex = resolutionKeys.indexOf(resolution);

  const createdAt = new Date(currentPlan?.plan?.createdAt);
  const planPurchaseDate = isNaN(createdAt.valueOf())
    ? ""
    : `${createdAt?.getDate()}/${createdAt?.getMonth() + 1
    }/${createdAt?.getFullYear()}`;

  const validityValue = parseInt(currentPlanDetails?.validity, 10) || 0;
  const [remainingDays, setRemainingDays] = useState("");
  const [remainingHours, setRemainingHours] = useState(0);
  const [remainingMinutes, setRemainingMinutes] = useState(0);
  const [remainingSeconds, setRemainingSeconds] = useState(0);
  const [unsubscribeState, setUnsubscribeState] = useState(false);
  const [buyBackActive, setBuyBackActive] = useState();

  const [min, setMin] = useState(0);
  const [sec, setSec] = useState(0);

  const today = new Date();
  const planRenewDate = new Date(
    createdAt?.getTime() + validityValue * 24 * 60 * 60 * 1000,
  );
  let timeDifference = planRenewDate - today;

  useEffect(() => {
    let prevRemainingDays = remainingDays;
    if (remainingDays === 1 || validityValue === 1) {
      const interval = setInterval(() => getTime(prevRemainingDays), 1000);
      return () => clearInterval(interval);
    } else {
      getTime(prevRemainingDays);
    }
    const purchaseDate = currentPlan?.plan?.createdAt;
    if (purchaseDate) {
      const purchaseTime = new Date(purchaseDate);
      const buyBackTime = new Date(
        purchaseTime.getTime() + 3 * 24 * 60 * 60 * 1000,
      );
      const isBuyBackActive = buyBackTime >= new Date();

      setBuyBackActive(isBuyBackActive);
    }

    dispatch(getUserAllInformation());
  }, []);

  useEffect(() => {
    getRenderPlanDetails();
  }, [isSuccessOpen]);
  const getTime = async (prevRemainingDays) => {
    if (!isNaN(validityValue)) {
      if (timeDifference > 0) {
        if (timeDifference >= 24 * 60 * 60 * 1000) {
          const updatedRemainingDays = Math.ceil(
            timeDifference / (24 * 60 * 60 * 1000),
          );
          timeDifference -= updatedRemainingDays * 24 * 60 * 60 * 1000;

          if (prevRemainingDays === 1 && updatedRemainingDays === 0) {
            setRemainingHours(0);
            setRemainingMinutes(0);
            setRemainingSeconds(0);
            setIsUserPaid(false);
          }
          setRemainingDays(updatedRemainingDays);
        }
        if (timeDifference >= 60 * 60 * 1000) {
          setRemainingHours(Math.floor(timeDifference / (60 * 60 * 1000)));
          timeDifference -= remainingHours * 60 * 60 * 1000;
        }

        if (timeDifference >= 60 * 1000) {
          setRemainingMinutes(Math.floor(timeDifference / (60 * 1000)));
          timeDifference -= remainingMinutes * 60 * 1000;
        }

        setRemainingSeconds(Math.floor(timeDifference / 1000));
      } else if (remainingDays === 0) {
        setIsUserPaid(false);
      } else {
        setRemainingDays(0);
        setRemainingHours(0);
        setRemainingMinutes(0);
        setRemainingSeconds(0);
      }
    }
  };
  const handleFpsChange = (value) => {
    const next = Number(value);
    setFps(next);
    persistStoredFps(next);
  };

  const handleResolutionChange = (val) => {
    setResolution(val);
    persistStoredResolution(val);
    if (!renderSettingsOptions[val].fps.includes(fps)) {
      handleFpsChange(renderSettingsOptions[val].fps[0]);
    }
    setAspectRatio(renderSettingsOptions[val].aspectRatio);
  };

  useEffect(() => {
    const allowed = resolutionsForAspectFrame(aspectRatio_FrameSize);
    if (!allowed.length || allowed.includes(resolution)) return;
    const next = allowed[0];
    setResolution(next);
    persistStoredResolution(next);
    const nextSettings = renderSettingsOptions[next];
    if (!nextSettings) return;
    setAspectRatio(nextSettings.aspectRatio);
    if (!nextSettings.fps.includes(fps)) {
      handleFpsChange(nextSettings.fps[0]);
    }
  }, [aspectRatio_FrameSize, resolution, fps]);

  const handleFormatChange = (val) => {
    setFormats(val);
  };

  const handleSpeedChange = (value) => {
    const next = Number(value);
    setSpeed(next);
    persistStoredSpeed(next);
  };

  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  const getRenderPlanDetails = async () => {
    await dispatch(getRendersPlan(user));
    await dispatch(getCurrentPlan());
  };

  const getHeight = () => {
    const resolutionSettings = renderSettingsOptions[resolution];
    if (!resolutionSettings) {
      setMin(0);
      setSec(0);
      return;
    }
    // Same resolution + mapped sppf as export so the UI clock matches the
    // file about to be rendered. Same-AR family times stay aligned via the
    // height-scaled sppf table.
    const { width: videoWidth, height: videoHeight } = resolutionSettings;
    const sppf = getSpfForSpeed({
      resolutionKey: resolution,
      videoHeight,
      speed,
    });
    const { num: fpsNum, den: fpsDen } = fpsNumAndDen[fps] || {};
    const { min, sec } = getScrollRunningTime({
      videoWidth,
      videoHeight,
      sppf,
      fps,
      fpsNum,
      fpsDen,
      endHoldEnabled: Boolean(projectSettings?.end_hold_enabled),
    });
    setMin(min);
    setSec(sec);
  };

  const handleExport = async () => {
    setLoading(true);

    const { width: videoWidth, height: videoHeight } =
      renderSettingsOptions[resolution];
    const scrollPixelPerFrame = getSpfForSpeed({
      resolutionKey: resolution,
      videoHeight,
      speed,
    });
    const { num: fpsNumerator, den: fpsDenominator } = fpsNumAndDen[fps];

    const focusedNode = document.getElementById("view_" + currentBlockIdx);
    const element = document.getElementById("preview");
    const previewContainer = document.getElementById("preview-container");
    const shownWatermarks = [];
    const focusClassBackup = [];
    const previewHadScrollable = element?.classList?.contains("scrollable");
    const previousFocusBorderColor = focusedNode?.style?.borderColor;
    const previewWasHidden = previewContainer?.classList?.contains(
      "is-render-page-hidden",
    );
    previewContainer?.classList.remove("is-render-page-hidden");

    try {
      if (!element) {
        throw new Error(
          "Preview element not found. Please close and reopen the Render panel and try again.",
        );
      }

      // Keep the focus border's box (transparent) so removing it cannot
      // widen the column and pull a wrapped word back up a line.
      // Side-by-side puts .focusDiv on the inner 50% column, not #view_N.
      const focusEls = [
        ...document.querySelectorAll(".focusDiv, .CardfocusDiv, .viewBlockfocusDiv"),
      ];
      if (focusedNode && !focusEls.includes(focusedNode)) {
        focusedNode.style.borderColor = "transparent";
      }
      focusEls.forEach((el) => {
        focusClassBackup.push({ el, className: el.getAttribute("class") });
        el.classList.remove("focusDiv", "CardfocusDiv");
        if (el.classList.contains("viewBlockfocusDiv")) {
          el.classList.remove("viewBlockfocusDiv");
          el.classList.add("viewBlock");
        }
      });
      element.classList.remove("scrollable");

      if (!isUserPaid) {
        document
          .querySelectorAll(".blockWrapper .watermark_displaynone")
          .forEach((el) => {
            el.classList.replace("watermark_displaynone", "watermark");
            shownWatermarks.push(el);
          });
      }

      // Photograph the same canonical 800px layout the editor shows
      // (zoom is display-only). Relaying at videoWidth reflows RoleName
      // and makes the video differ from preview. generateBlockImages
      // keeps that layout but rasterizes directly on the export pixel grid.
      await document.fonts.ready;
      await sleep(150);

      const useAlpha = isAlphaRenderFormat(formats);
      const opaqueMatte = resolveOpaqueMatteColor(projectSettings);
      // Canvas export paints the same scene the canvas preview shows.
      const canvasExporter = isCanvasPreviewEnabled({ isCard, credits })
        ? await prepareCanvasExport({
            credits,
            settings: projectSettings,
            fontStyle,
            targetWidth: videoWidth,
            backgroundColor: useAlpha ? null : opaqueMatte,
            watermark: !isUserPaid,
          })
        : null;
      const images = canvasExporter
        ? await canvasExporter.blocks()
        : await generateBlockImages({
        targetWidth: videoWidth,
        preserveLayoutHeight: true,
        rasterizeAtTargetWidth: true,
        preserveRoleNamePositions: true,
        preserveHeadingSpacing: true,
        bakeRoleNamePad: true,
        backgroundColor: useAlpha ? null : opaqueMatte,
        getBackgroundStyleForBlock: useAlpha
          ? () => ({ backgroundColor: "transparent" })
          : (block, _idx, offsetY) =>
              getScrollBlockBackgroundStyle(
                { ...projectSettings, matte_color: opaqueMatte },
                offsetY,
                block.offsetWidth,
              ),
      });

      const blankScreen = await createBlankPng({
        width: videoWidth,
        height: videoHeight,
        color: useAlpha ? "transparent" : opaqueMatte,
      });
      const endHoldTiming = projectSettings?.end_hold_enabled
        ? getRenderEndHoldTiming({
            images,
            videoHeight,
            scrollPixelPerFrame,
            fpsNumerator,
            fpsDenominator,
          })
        : null;
      const endHoldAssets = !endHoldTiming
        ? null
        : canvasExporter
        ? await canvasExporter.endHold()
        : await generateEndHoldAssets({
            targetWidth: videoWidth,
            targetHeight: images[images.length - 1]?.height,
            rasterizeAtTargetWidth: true,
            preserveRoleNamePositions: true,
            preserveHeadingSpacing: true,
            backgroundColor: useAlpha ? null : opaqueMatte,
            getBackgroundStyleForBlock: useAlpha
              ? () => ({ backgroundColor: "transparent" })
              : (block, _idx, offsetY) =>
                  getScrollBlockBackgroundStyle(
                    { ...projectSettings, matte_color: opaqueMatte },
                    offsetY,
                    block.offsetWidth,
                  ),
          });
      const renderImages = endHoldAssets
        ? [
            ...images.slice(0, -1),
            { ...images[images.length - 1], blob: endHoldAssets.background.blob },
          ]
        : images;
      const imagesWithBlanks = [
        { ...blankScreen, idx: 0 },
        ...renderImages.map((image, i) => ({ ...image, idx: i + 1 })),
        { ...blankScreen, idx: images.length + 1 },
      ];

      localStorage.setItem(
        "renderSettings",
        JSON.stringify({
          resolution,
          format: formats,
          speed,
          fps,
        }),
      );

      const renderResult = await dispatch(
        requestRenderXVideo(
          imagesWithBlanks,
          {
            videoHeight,
            videoWidth,
            scrollPixelPerFrame,
            fpsDenominator,
            fpsNumerator,
            format: formats === "H264" ? "outputH264" : formats,
            aspectRatio,
            isEmailSend,
            endHoldEnabled: Boolean(endHoldTiming),
            endHoldStopSeconds: endHoldTiming?.stopSeconds ?? 0,
            endHoldDurationSeconds: endHoldTiming?.holdSeconds ?? 0,
            endHoldFadeSeconds: endHoldTiming?.fadeSeconds ?? 0,
            endHoldLastBlockTopPixels:
              endHoldTiming?.lastBlockTopPixels ?? 0,
            endHoldLastBlockHeightPixels:
              endHoldTiming?.lastBlockHeightPixels ?? 0,
            endHoldLastBlockStartFrame:
              endHoldTiming?.lastBlockStartFrame ?? 0,
          },
          endHoldAssets
            ? { endHoldForeground: endHoldAssets.foreground.blob }
            : undefined,
        ),
      );

      if (renderResult?.success) {
        dispatch(increaseRenderCnt());
        setRenderOpen(false);
        setIsRenderExport(true);
        toast(<CustomToast title="" content={mesg} />, customToatStyle);
        const newRender = renderResult.renders;
        const renderId = newRender[newRender.length - 1]._id;

        const notifyObj = {
          name: "render",
          details: newRender[newRender.length - 1],
          project_id: _id,
          render_id: renderId,
          message: `Rendering Completed ${newRender[newRender.length - 1].videoFilename}`,
          status: 1,
          user_id: user._id,
        };
        setCurrentNotification(notifyObj);

        await dispatch(
          addNotifications({
            project_id: _id,
            render_id: renderId,
            message: `Render in progress ${newRender[newRender.length - 1].videoFilename}`,
            status: 1,
            user_id: user._id,
          }),
        );

        setTimeout(() => window.location.reload(), 100);
      } else {
        toast(<CustomToast title="" content={"Failed"} />, customToatStyle);
      }
    } catch (err) {
      console.error(err);
      toast(
        <CustomToast
          title=""
          content={err?.message || "Failed to start render"}
        />,
        customToatStyle,
      );
    } finally {
      // Back to the on-screen editor layout.
      dispatch(updatePreviewScale(1));
      shownWatermarks.forEach((el) => {
        el.classList.replace("watermark", "watermark_displaynone");
      });
      if (focusedNode) {
        focusedNode.style.borderColor = previousFocusBorderColor || "";
      }
      focusClassBackup.forEach(({ el, className }) => {
        if (el && className != null) el.setAttribute("class", className);
      });
      if (previewHadScrollable) {
        element?.classList?.add("scrollable");
      }
      if (previewWasHidden) {
        previewContainer?.classList.add("is-render-page-hidden");
      }
      setLoading(false);
    }
  };


  const handleExportSubmit = () => {
    console.log("1 Scroll Render Start handleExportSubmit Verify User Paid or Not => ");
    if (!renderDone && buyBackActive) {
      dispatch(markRenderDone());
    }

    if (isUserPaid) {
      console.log("! Scroll Render Start handleExportSubmit => Paid User ", isUserPaid);
      handleExport();
    }

    if (!isUserPaid) {
      console.log("! Scroll Render Start handleExportSubmit => Not Paid User");
      navigate("/user-plans", {
        state: {
          isRender: true,
          isMoreInfo: false,
          isCard: isCard,
          projectId: projectId ?? null,
        },
      });
      return;
    }
  };

  renders = renders?.sort(
    (a, b) => new Date(b?.createdAt) - new Date(a?.createdAt),
  );

  const frameResolutions = resolutionsForAspectFrame(aspectRatio_FrameSize);
  const paideRenderSettingsOptions = frameResolutions.map((resolutionType) => ({
    label: resolutionType,
    value: resolutionType,
  }));
  const frameFreeRenderSettingsOptions = freeRenderSettingsOptions.filter(
    (option) => frameResolutions.includes(option.value),
  );
  const paideRenderFormats = Object.entries(format).map(([key, value]) => ({
    label: key,
    value: value,
  }));
  const paidFramRate = renderSettingsOptions[resolution]?.fps?.map((_fps) => ({
    label: _fps,
    value: _fps,
  }));
  const expirationMessage =
    Object.keys(currentPlan).length === 0
      ? "With scrollx watermark"
      : remainingDays === 0
        ? "Plan Expired"
        : remainingDays === 1 || validityValue === 1
          ? `Plan Expires in ${remainingHours}:${remainingMinutes}:${remainingSeconds}`
          : remainingDays > 1
            ? `Remaining ${remainingDays} days`
            : "";

  function addIntervalToPurchaseDate(
    planPurchaseDate,
    interval_count,
    interval_type,
  ) {
    const purchaseDate = planPurchaseDate; // Convert purchase date to Date object

    // Check if the purchase date is valid
    if (isNaN(purchaseDate)) {
      return null;
    }

    // Based on the interval_type, add to the date accordingly
    switch (interval_type) {
      case "day":
        purchaseDate.setDate(purchaseDate.getDate() + interval_count);
        break;
      case "month":
        purchaseDate.setMonth(purchaseDate.getMonth() + interval_count);
        break;
      case "year":
        purchaseDate.setFullYear(purchaseDate.getFullYear() + interval_count);
        break;
      default:
        throw new Error("Invalid interval type");
    }

    // Return date in YYYY-MM-DD format
    return purchaseDate;
  }

  const expirationDate =
    currentPlanDetails !== null
      ? addIntervalToPurchaseDate(
        createdAt,
        currentPlanDetails?.interval_count,
        currentPlanDetails?.interval,
      )
      : new Date();

  const expiryString =
    currentPlanDetails !== null && expirationDate !== null
      ? `Expiration Date ${expirationDate.getDate()}/${expirationDate.getMonth() + 1
      }/${expirationDate.getFullYear()}`
      : "";

  const renewalString =
    currentPlanDetails !== null && expirationDate !== null
      ? `Renewal Date ${expirationDate.getDate()}/${expirationDate.getMonth() + 1
      }/${expirationDate.getFullYear()}`
      : "";

  const currentDate = new Date();
  const isPlanActive = currentDate < expirationDate;

  useEffect(() => {
    getHeight();
  }, [speed, fps, resolution, credits, projectSettings]);

  return (
    <>
      <EC_Render isOpen={renderOpen} closeModal={() => setRenderOpen(false)}>
      {loading ? (
        <div className="requestLoader">
          <img className="absolute opacity-80" width="120px" height="120px" src={Scrollx_animate} />
          <p className="mt-[8rem] text-[0.9rem] text-white">Requesting Video ... </p>
        </div>
      ) : null}

      {/* <ConfirmationModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onConfirm={handleConfirm}
        message="By clicking 'Render', you agree that the 3-day money-back guarantee will be void. Are you sure you want to continue?"
      /> */}

      <div className="bodyContainer" style={{ minHeight: "100vh", minHeight: "-webkit-fill-available" }}>

        <div className="particles"></div>

        <div className="layoutContainer-shell">

          <header className='header-topbar' >
            <RenderNavbar closeModal={() => setRenderOpen(false)} />
          </header>

          {/* zoom scaling applies to page content only, so the navbar stays a fixed height */}
          <main className="renderPage-Container responsiveZoomClass w-full max-w-[1388px] mx-auto px-4 md:px-8 py-8 md:py-10">

            <section className="mx-auto topSection">
              <div className=" renderSection1">
                <RenderSettings 
                  renderOpen={renderOpen} 
                  IsUpgradeOpen={IsUpgradeOpen}

                  isCard={isCard}
                  
                  resolution={resolution}
                  handleResolutionChange={handleResolutionChange}
                  resolutionIndex={resolutionIndex}
                  aspectFrame={aspectRatio_FrameSize}
                  onAspectFrameChange={setAspectRatio_FrameSize}
                   
                  freeRenderSettingsOptions={frameFreeRenderSettingsOptions}

                  freeRenderFormats={freeRenderFormats} 
                  formats={formats}
                  handleFormatChange={handleFormatChange}

                   
                  freeFramRate={freeFramRate}
                  paidFramRate={paidFramRate}

                  fps={fps} 
                  setFps={handleFpsChange}

                  speed={speed}
                  setSpeed={handleSpeedChange}

                  min={min} 
                  sec={sec}
                  
                  isEmailSend={isEmailSend} 
                  setIsEmailSend={setIsEmailSend}
                  
                  handleScrollRenderExport={handleExportSubmit} 
                  isLoading={isLoading}
                  loading={loading}

                  renderCnt={3}
                  
                  isUserPaid={isUserPaid}
                  isPlanActive={isPlanActive} 
                  
                  paideRenderSettingsOptions={paideRenderSettingsOptions}

                  paideRenderFormats={paideRenderFormats}                 

                />
              </div>
            </section>

            <section className='mx-auto bottomSection'>
              <div className=" renderSection2">
                <RendersTable />
              </div>
            </section>

          </main>

        </div>
      </div>
</EC_Render>

    </>
  )
}

export default ScrollRender;
